import {
  SET_ALL_MEDIA,
  ALL_MEDIA_CURRENT_PAGE,
  TOTAL_MEDIA_PAGES,
  LOADING_REMOVE_MEDIA,
  REMOVED_MEDIA_ID,
  GET_ALL_GALLERIES,
  ALL_GALLERIES_CURRENT_PAGE,
  TOTAL_GALLERY_PAGES,
} from "../../@jumbo/constants/ActionTypes";

export const setAllMedia = (media) => {
  return (dispatch) => {
    dispatch({
      type: SET_ALL_MEDIA,
      payload: media,
    });
  };
};

export const setMediaCurrentPage = (currentPage) => {
  return (dispatch) => {
    dispatch({
      type: ALL_MEDIA_CURRENT_PAGE,
      payload: currentPage,
    });
  };
};

export const setTotalMediaPages = (totPageCnt) => {
  return (dispatch) => {
    dispatch({
      type: TOTAL_MEDIA_PAGES,
      payload: totPageCnt,
    });
  };
};

export const setloadingRemoveMedia = (loadingStatus) => {
  return (dispatch) => {
    dispatch({
      type: LOADING_REMOVE_MEDIA,
      payload: loadingStatus,
    });
  };
};

export const setRemovedMediaId = (removedMediaId) => {
  return (dispatch) => {
    dispatch({
      type: REMOVED_MEDIA_ID,
      payload: removedMediaId,
    });
  };
};

export const getAllGalleries = (galleries) => {
  return (dispatch) => {
    dispatch({
      type: GET_ALL_GALLERIES,
      payload: galleries,
    });
  };
};

export const setGalleryCurrentPage = (curr) => {
  return (dispatch) => {
    dispatch({
      type: ALL_GALLERIES_CURRENT_PAGE,
      payload: curr,
    });
  };
};

export const setTotalGalleryPage = (total) => {
  return (dispatch) => {
    dispatch({
      type: TOTAL_GALLERY_PAGES,
      payload: total,
    });
  };
};
